module.exports = __webpack_public_path__ + "img/background-video-slider-mitsu.8fe89920.jpg";